import React from 'react';
import { Box, Group, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import type { CalendarItem, CalendarSource } from '../../hooks/useCalendarApi';
import { sourceDot } from './sourceColor';

/**
 * Расшифровка цветов. Показываем только те источники, что есть в этом месяце:
 * полный справочник из шести пунктов под пустой сеткой — шум.
 */
export const SourceLegend: React.FC<{ items: CalendarItem[] }> = ({ items }) => {
  const { t } = useTranslation();

  const present: CalendarSource[] = [];
  for (const item of items) {
    if (!present.includes(item.source)) present.push(item.source);
  }
  if (present.length < 2) return null;

  return (
    <Group gap="md" wrap="wrap">
      {present.map((source) => (
        <Group key={source} gap={6} wrap="nowrap">
          <Box
            aria-hidden
            style={{
              width: 8,
              height: 8,
              borderRadius: '50%',
              background: sourceDot(source),
            }}
          />
          <Text size="xs" c="dimmed">
            {t(`calendar.source.${source}`)}
          </Text>
        </Group>
      ))}
    </Group>
  );
};
